import * as React from "react";
import { Image } from "../../../models/common";
import { Text } from "../../../uikit";
import { IoGrid } from "@react-icons/all-files/io5/IoGrid";
import { IoImageOutline } from "@react-icons/all-files/io5/IoImageOutline";
import { IoChevronForward } from "@react-icons/all-files/io5/IoChevronForward";
import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
import { Navigation, Pagination } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import LikeShare from "../likeShare";
import { Course } from "@kalabo/golfsavers-common";
import { Hotel } from "@kalabo/golfsavers-common";

interface IProps {
  course: Course | Hotel;
  images: Image[]; //item comes in as a stringified array
  recommended?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const HeroImages = ({
  course,
  images,
  recommended = false,
  onClick,
}: IProps) => {
  const images_array = images;

  if (images_array?.length === 0) {
    return null;
  }

  let image_one = images_array?.length > 0 ? images_array[0] : null;
  let image_two = images_array?.length > 1 ? images_array[1] : null;
  let image_three = images_array?.length > 2 ? images_array[2] : null;
  let image_four = images_array?.length > 3 ? images_array[3] : null;
  let image_five = images_array?.length > 4 ? images_array[4] : null;

  return (
    <div className="-mx-5 sm:mx-0 ">
      <div className="sm:hidden relative">
        <span className="sm:hidden absolute bottom-3 right-5 text-12 z-[999] font-semibold px-[8px] py-[3px] leading-[100%] flex items-center rounded-sm text-white bg-black/60">
          <IoImageOutline className="h-4 w-4 mr-1" aria-hidden="true" />
          {images_array?.length}
        </span>
        <div className="absolute top-3 right-5 z-[999]">
          <LikeShare value={course?.slug} name={course?.name?.en} />
        </div>
        <div className="relative">
          <Swiper
            spaceBetween={0}
            breakpoints={{
              // when window width is >= 320px
              320: {
                slidesPerView: 1,
              },
              // when window width is >= 640px
              640: {
                slidesPerView: 1,
              },
              // when window width is >= 768px
              1024: {
                slidesPerView: 1,
              },
            }}
            pagination={{
              clickable: true,
              el: "#swiper-hero-pagination",
              dynamicBullets: true,
            }}
            modules={[Pagination]}
            className="h-full pr-6 lg:pr-0"
          >
            {images_array?.map((image, index) => {
              return (
                <SwiperSlide key={index}>
                  <div
                    onClick={(e) => {
                      onClick(e);
                    }}
                    className="bg-grey3 cursor-pointer group overflow-hidden aspect-h-2 aspect-w-3 sm:aspect-h-3 sm:aspect-w-4 sm:row-span-2 sm:col-span-6 hover:brightness-[0.8] transition-all relative"
                  >
                    <img
                      src={`${process.env.GATSBY_IMAGE_PREFIX}${image?.url}?quality=70`}
                      alt={image?.alt}
                      className="object-center object-cover aspect-[5/3] sm:aspect-auto"
                    />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <div
            id="swiper-hero-pagination"
            className="swiper-white absolute z-50 !-bottom-[10px] !gap-2 w-full h-8 mt-5"
          ></div>
        </div>
      </div>
      <div className="relative sm:mt-2 grid grid-cols-1 gap-y-1 sm:grid-cols-12 sm:grid-rows-2 sm:gap-x-1 sm:rounded-lg overflow-hidden ">
        {recommended && (
          <div className="hidden sm:block absolute bg-darkorange pt-[4.5px] pb-[4.5px] px-[10px] z-[5] top-3 left-3 rounded">
            <Text
              size={13}
              sizeDesktop={17}
              sizeTablet={15}
              weight="semibold"
              element={"h4"}
              color="white"
              className="uppercase"
            >
              Recommended
            </Text>
          </div>
        )}
        <div
          className="absolute hidden sm:flex bg-white pt-[6px] pb-[5px] px-[6px] z-10 bottom-3 right-3 rounded  flex-row items-center shadow cursor-pointer"
          onClick={(e) => {
            onClick(e);
          }}
        >
          <IoGrid
            className="h-5 w-5 text-grey7 inline items-center"
            aria-hidden="true"
          />

          <Text
            size={11}
            className=" ml-1 mb-0 pb-0 hidden lg:block"
            color="grey6"
          >
            Show all photos
          </Text>
        </div>

        {image_one && (
          <div
            onClick={(e) => {
              onClick(e);
            }}
            className="bg-grey3 cursor-pointer hidden sm:block group overflow-hidden aspect-h-2 aspect-w-3 sm:aspect-h-3 sm:aspect-w-4 sm:row-span-2 sm:col-span-6 hover:brightness-[0.8] transition-all relative"
          >
            <img
              src={`${process.env.GATSBY_IMAGE_PREFIX}${image_one?.url}?quality=70`}
              alt={image_one?.alt}
              className="object-center object-cover aspect-[5/3] sm:aspect-auto"
            />
          </div>
        )}
        {image_two && (
          <div
            onClick={(e) => {
              onClick(e);
            }}
            className="bg-grey3 cursor-pointer hidden sm:block group aspect-w-2 aspect-h-1 overflow-hidden sm:relative sm:aspect-none sm:h-full sm:col-span-3 hover:brightness-[0.8] transition-all"
          >
            <img
              src={`${process.env.GATSBY_IMAGE_PREFIX}${image_two?.url}?quality=70`}
              alt={image_two?.alt}
              className="object-center object-cover sm:absolute sm:inset-0 sm:w-full sm:h-full"
            />
          </div>
        )}
        {image_three && (
          <div
            onClick={(e) => {
              onClick(e);
            }}
            className="bg-grey3 cursor-pointer hidden sm:block group aspect-w-2 aspect-h-1 overflow-hidden sm:relative sm:aspect-none sm:h-full sm:col-span-3 hover:brightness-[0.8] transition-all"
          >
            <img
              src={`${process.env.GATSBY_IMAGE_PREFIX}${image_three?.url}?quality=70`}
              alt={image_three?.alt}
              className="object-center object-cover  sm:absolute sm:inset-0 sm:w-full sm:h-full"
            />
          </div>
        )}
        {image_four && (
          <div
            onClick={(e) => {
              onClick(e);
            }}
            className="bg-grey3 cursor-pointer hidden sm:block group aspect-w-2 aspect-h-1 overflow-hidden sm:relative sm:aspect-none sm:h-full sm:col-span-3 hover:brightness-[0.8] transition-all"
          >
            <img
              src={`${process.env.GATSBY_IMAGE_PREFIX}${image_four?.url}?quality=70`}
              alt={image_four?.alt}
              className="object-center object-cover sm:absolute sm:inset-0 sm:w-full sm:h-full"
            />
          </div>
        )}
        {image_five && (
          <div
            onClick={(e) => {
              onClick(e);
            }}
            className="bg-grey3 cursor-pointer hidden sm:block group aspect-w-2 aspect-h-1 overflow-hidden sm:relative sm:aspect-none sm:h-full sm:col-span-3 hover:brightness-[0.8] transition-all"
          >
            <img
              src={`${process.env.GATSBY_IMAGE_PREFIX}${image_five?.url}?quality=70`}
              alt={image_five?.alt}
              className="object-center object-cover  sm:absolute sm:inset-0 sm:w-full sm:h-full"
            />
          </div>
        )}
      </div>
    </div>
  );
};

interface iBackProps {
  onClick: React.MouseEventHandler<HTMLDivElement>;
}

const BackButton = ({ onClick }: iBackProps) => {
  return (
    <div
      className="sm:hidden absolute left-3 top-3 shadow sm:shadow-none sm:border w-9 h-9 items-center flex justify-center rounded-full border-grey7 bg-white cursor-pointer"
      onClick={onClick}
    >
      <IoChevronForward
        className="h-4 w-4 rotate-180 text-grey7 inline items-center"
        aria-hidden="true"
      />
    </div>
  );
};

export default HeroImages;
